import { Info, X } from "lucide-react";
import { cn } from "@repo/utils";
import { iconVariants, toastVariants } from "./toast-variants.js";
import { TOAST_ICONS, TOAST_VARIANTS } from "./toast.config.js";
import type { Toast, ToastType } from "./toast.types.js";
import { Alert, AlertDescription, AlertTitle } from "../ui/alert.js";

type ToastItemProps = {
  toast: Toast;
  onRemove: (id: string) => void;
};

export const ToastItem = ({ toast, onRemove }: ToastItemProps) => {
  const IconComponent = TOAST_ICONS[toast.type] || Info;

  const getIcon = (type: ToastType): React.ReactElement => {
    return <IconComponent className={iconVariants({ type })} />;
  };

  return (
    <div className="pointer-events-auto">
      <Alert
        variant={TOAST_VARIANTS[toast.type]}
        className={cn(
          `animate-slide-in relative !flex min-w-80 rounded-md p-4 shadow-lg`,
          toastVariants({ type: toast.type })
        )}
      >
        <button
          data-allow-navigation
          onClick={() => onRemove(toast.id)}
          className="absolute top-3 right-3 z-10 cursor-pointer text-inherit opacity-70 transition-opacity hover:opacity-100"
          aria-label="Close notification"
        >
          <X className="h-4 w-4" />
        </button>

        <div className="flex min-w-96 items-start gap-3 pr-8">
          <div className="mt-0.5 text-inherit">{getIcon(toast.type)}</div>
          <div className="flex-1">
            {toast.title && (
              <AlertTitle className="mb-1 size-fit text-sm font-semibold">{toast.title}</AlertTitle>
            )}
            <AlertDescription className="!block text-sm leading-normal text-inherit">
              {toast.message}
            </AlertDescription>
          </div>
        </div>
      </Alert>
    </div>
  );
};
